import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { User } from '®shared/auth';
import {
  ConfirmInlineNoteEditorEvent,
  InlineNoteEditorType,
} from '®shared/inline-note';

import {
  ResourceId,
  ResourceNote,
  SaveableStudyNote,
  StudyNoteMode,
} from './study-note';

type SaveableStudyNoteAliased = SaveableStudyNote;

/**
 * A component that allows the user to create, view, update, and delete a study note.
 */
@Component({
  selector: 'rl-study-note',
  templateUrl: './study-note.component.html',
})
export class StudyNoteComponent implements OnChanges {
  @Input() resourceId: string;
  @Input() mode: StudyNoteMode;
  @Input() studyNote: SaveableStudyNoteAliased;
  @Input() timestamp?: string;
  @Input() user: User;

  @Output() cancel = new EventEmitter<ResourceId>();
  @Output() update = new EventEmitter<ResourceNote>();
  @Output() delete = new EventEmitter<ResourceId>();

  InlineNoteEditorType = InlineNoteEditorType;
  StudyNoteMode = StudyNoteMode;

  /**
   * Reference note's original state for swapping between modes
   */
  state: { mode: StudyNoteMode; note: string };

  /**
   * Updates state object permitting reset
   */
  resetState() {
    this.state = {
      mode: this.mode || StudyNoteMode.VIEW,
      note: (this.studyNote && this.studyNote.note) || undefined,
    };
  }

  /**
   * Resets our state object to what's provided in the component's
   * mode and study note bindings - or a default value
   */
  ngOnChanges(_changes?: SimpleChanges) {
    this.resetState();
  }

  onSubmit($event: ConfirmInlineNoteEditorEvent) {
    this.update.emit({ resource: this.resourceId, note: $event.note });
    this.resetState();
  }

  onDelete() {
    this.resetState();
    this.delete.emit({ resource: this.resourceId });
  }

  onCancel() {
    this.resetState();
    this.cancel.emit({ resource: this.resourceId });
  }
}
